import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberOrDash',
    standalone: false
})
export class NumberOrDashPipe implements PipeTransform {

    transform(value: number | null | undefined, format: string = '1.2-2'): string {
        return value != null ? new Intl.NumberFormat('nl-NL', {
            minimumFractionDigits: 2, maximumFractionDigits: 2
        }).format(value) : '-';
    }

}
